import { Alert, AlertTitle, Box, Stack, Tooltip } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import {
    getActivePartialPtsVisibilityMessages,
    hasPartialPtsVisibility,
} from '../../Configurations/invoicingConfig';

const WARNING_ICON_SX = {
    color: '#B86E00',
    fontSize: 18,
    verticalAlign: 'middle',
};

/**
 * Row-level visual indicator when any partial PTS visibility flag is true.
 * Same treatment on Invoice Initiation and Invoice Management.
 */
export function PartialPtsVisibilityIndicator({ context, timesheet, sx }) {
    if (!hasPartialPtsVisibility(context, timesheet)) {
        return null;
    }

    const titles = getActivePartialPtsVisibilityMessages(context, timesheet)
        .map(({ title }) => title)
        .join('; ');

    return (
        <Tooltip title={titles} placement="top">
            <WarningAmberIcon
                data-testid="partial-pts-visibility-indicator"
                sx={{ ...WARNING_ICON_SX, ...sx }}
            />
        </Tooltip>
    );
}

/**
 * Stacked warning messages for active partial PTS visibility flags.
 * Multiple flags can be true at once — all matching messages are shown.
 */
export default function PartialPtsVisibilityMessages({ context, timesheet, sx }) {
    const messages = getActivePartialPtsVisibilityMessages(context, timesheet);
    if (messages.length === 0) {
        return null;
    }

    return (
        <Box
            sx={sx}
            data-testid="partial-pts-visibility-messages"
            onClick={(e) => e.stopPropagation()}
        >
            <Stack gap={1}>
                {messages.map(({ flag, title, body }) => (
                    <Alert
                        key={flag}
                        severity="warning"
                        data-testid={`partial-pts-visibility-message-${flag}`}
                    >
                        <AlertTitle>{title}</AlertTitle>
                        <Box component="span" sx={{ fontSize: 13 }}>
                            {body}
                        </Box>
                    </Alert>
                ))}
            </Stack>
        </Box>
    );
}
